export default __webpack_public_path__ + "static/media/show9.6420f628.jpeg";